












import { Component, Vue } from "vue-property-decorator";
// eslint-disable-next-line sort-imports
import { namespace, State } from "vuex-class";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import BlacklistCreate from "@/views/blacklist/components/BlacklistCreate.vue";
import BlacklistModule from "@/store/modules/blacklist";
import { BlacklistState } from "@/models/store/BlacklistState";
import BlacklistTable from "@/views/blacklist/components/BlacklistTable.vue";

const blacklist = namespace(BlacklistModule.name);

@Component({
  name: "Index",
  components: { ApplicationLayout, BlacklistCreate, BlacklistTable }
})
export default class Index extends Vue {
  // ===== Store ===== //
  @State("blacklist") private readonly blacklist!: BlacklistState;
  @blacklist.Action("getBlacklistReasons") public getBlacklistReasons!: () => void;
  @blacklist.Action("getBlacklistTenants") public getBlacklistTenants!: () => void;

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Watchers ===== //

  // ===== Computed ===== //

  // ===== Lifecycle Hook ===== //
  private created() {
    this.getBlacklistTenants();
    this.getBlacklistReasons();
  }
}
